import fs from 'node:fs';

/** Write credential-bearing state without ever exposing its new contents as group/world-readable. */
export function writePrivateFileSync(filePath: string, content: string): void {
  const descriptor = fs.openSync(filePath, 'w', 0o600);
  try {
    // The mode argument only applies on creation. Tighten legacy files before
    // writing the new secret-bearing contents as part of the same open handle.
    fs.fchmodSync(descriptor, 0o600);
    fs.writeFileSync(descriptor, content, 'utf8');
  } finally {
    fs.closeSync(descriptor);
  }
}
